<div class="container mb-4 scroll-to arabic-styling next-design">
    <div class="row justify-content-center">
      <div class="col-sm-12 col-md-8">
        <div class="alert alert-danger">
          <h4
            class="alert-heading"
            innerText="{{'UserProfile.UAEPASSLoginError' | translate}}"
          ></h4>
          <p
            class="mb-0"
            innerHtml="{{'UserProfile.UAEPASSLoginErrorMessage' | translate}}"
          ></p>
          <div class="ds-btn-container my-2">
            <a
            routerLink="/login"
              class="ds-btn ds-btn-secondary"
            >{{'UserProfile.Login' | translate}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>